import React from "react";

import { useAuth } from "@hubcapp/context";
import LessonDetails from "./LessonDetails";
import useLearnerLessonDetails from "./hooks/useLearnerLessonDetails";

const LessonDetailsStateProvider: React.FC<{ learnerId?: string }> = ({
  learnerId,
}) => {
  const {
    instructor: { id: instructorId },
  } = useAuth();

  const { loading, data } = useLearnerLessonDetails(learnerId, instructorId);

  return (
    <LessonDetails
      loading={loading}
      lessonBalances={data?.learner.lessonBalances}
      name={data?.learner.name}
      pickupAddress={data?.learner.pickupAddress}
      allocations={data?.learner.allocations}
    />
  );
};

export default LessonDetailsStateProvider;
